import { render, staticRenderFns } from "./cardVirtualAssistants.vue?vue&type=template&id=7da13438"
import script from "./cardVirtualAssistants.vue?vue&type=script&lang=js"
export * from "./cardVirtualAssistants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports